/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

import { NestedOption } from '../../../core/nested-option';


export abstract class DxoPositionConfig extends NestedOption {
    get at(): string|
        { x?: string, y?: string } {
        return this._getOption('at');
    }
    set at(value: string|
        { x?: string, y?: string }) {
        this._setOption('at', value);
    }

    get boundary(): Element|
        JQuery|
        Window {
        return this._getOption('boundary');
    }
    set boundary(value: Element|
        JQuery|
        Window) {
        this._setOption('boundary', value);
    }

    get boundaryOffset(): string|
        { x?: number, y?: number } {
        return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value: string|
        { x?: number, y?: number }) {
        this._setOption('boundaryOffset', value);
    }

    get collision(): string|
        { x?: string, y?: string } {
        return this._getOption('collision');
    }
    set collision(value: string|
        { x?: string, y?: string }) {
        this._setOption('collision', value);
    }

    get my(): string|
        { x?: string, y?: string } {
        return this._getOption('my');
    }
    set my(value: string|
        { x?: string, y?: string }) {
        this._setOption('my', value);
    }

    get of(): Element|
        JQuery|
        Window {
        return this._getOption('of');
    }
    set of(value: Element|
        JQuery|
        Window) {
        this._setOption('of', value);
    }

    get offset(): string|
        { x?: number, y?: number } {
        return this._getOption('offset');
    }
    set offset(value: string|
        { x?: number, y?: number }) {
        this._setOption('offset', value);
    }
}
